export default __webpack_public_path__ + "static/media/bwTheme-boy.fbbb191f.svg";